var _circle, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconLogbookNonMetallic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16,
    fill: "#12908D",
    stroke: "#fff",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.382 15.716c2.114-.907 4.86-.165 6.644 1.962 1.948 2.321 2.073 5.483.395 7.387a5.96 5.96 0 001.543-1.079l4.902-4.734a5.963 5.963 0 10-8.284-8.579l-4.902 4.734c-.104.1-.203.203-.298.309z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.03 18.513c1.781 2.123 1.552 4.785.078 6.022s-4.136 1-5.916-1.122c-1.781-2.123-1.552-4.785-.078-6.022s4.136-1 5.917 1.122z",
    stroke: "#4A5862",
    strokeWidth: 2.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.027 18.333c1.51-1.162 3.325.273 3.99 1.01.665.736 1.733 2.736.503 3.992-1.231 1.256-3.338.423-4.24-.647-.904-1.07-1.762-3.192-.253-4.355z",
    fill: "#F3F7F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.796 23.157l3.524-3.408s1.68 2.117.17 3.61c-1.51 1.492-3.694-.203-3.694-.203z",
    fill: "#E0DEDE"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogbookNonMetallic);
export default new URL("/builds/software-solutions/workspace/web/eagleid-fe-workspace/src/images/iconLogbookNonMetallic.svg", import.meta.url).toString();
export { ForwardRef as ReactComponent };